import UseSvg from "common/vue/components/UseSvg.react.vue";
import { injectHexColorPreviews, useMarkdownRenderer } from "./composables/useMarkdownRenderer";
import { renderList } from "common/vue/render-list";
import { cn } from "tailwind-variants";
import "./PinMessages.scss";

export default function PinMessages({
  messages = [],
  isProcessing = false,
  thinkingText = undefined,
  compact = false,
  ...restProps
}) {
  const { renderMarkdown } = useMarkdownRenderer();

  return (
    <>
      {messages.length > 0 || isProcessing ? (
        <div
          {...restProps}
          className={cn("scope-99187ea7", "flex flex-col", compact ? "gap-2" : "gap-4")}
        >
          {renderList(messages, msg => (
            <div
              className={cn(
                "scope-99187ea7",
                "flex flex-col text-sm",
                compact ? "gap-0.5" : "gap-1"
              )}
              key={msg.id}
            >
              <span
                className={cn(
                  "scope-99187ea7",
                  "font-bold uppercase",
                  compact ? "text-[9px]" : "text-[10px]",
                  msg.role === "user" ? "text-gray-400" : "text-blue-700"
                )}
              >
                {msg.role === "user" ? "ME" : "REDRAW ASSISTANT"}
              </span>
              {msg.role === "ai" ? (
                <div
                  className="pin-messages-markdown scope-99187ea7 text-gray-800"
                  dangerouslySetInnerHTML={{ __html: renderMarkdown(msg.content) }}
                />
              ) : (
                <div
                  className="scope-99187ea7 whitespace-pre-wrap text-gray-800"
                  dangerouslySetInnerHTML={{ __html: injectHexColorPreviews(msg.content) }}
                />
              )}
            </div>
          ))}
          {isProcessing ? (
            <div
              className={cn(
                "scope-99187ea7",
                "flex flex-col text-sm",
                compact ? "gap-0.5" : "gap-1"
              )}
            >
              <span
                className={cn(
                  "scope-99187ea7",
                  "font-bold uppercase text-blue-700",
                  compact ? "text-[9px]" : "text-[10px]"
                )}
              >
                {" "}
                REDRAW ASSISTANT{" "}
              </span>
              <div
                className={cn(
                  "scope-99187ea7",
                  "flex items-center",
                  compact ? "gap-1.5 text-xs" : "gap-2 text-sm"
                )}
              >
                <UseSvg
                  className={cn(
                    "scope-99187ea7",
                    "shrink-0 animate-spin text-blue-600",
                    compact ? "h-3.5 w-3.5" : "h-4 w-4"
                  )}
                  icon="loader"
                  data-testid="use-svg"
                />
                <span
                  className={cn("scope-99187ea7", "text-gray-500", compact ? "text-xs" : "text-sm")}
                >
                  {thinkingText || "Thinking..."}
                </span>
              </div>
            </div>
          ) : null}
        </div>
      ) : null}
    </>
  );
}
